<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Kullanıcı listesi</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Kullanıcı listesi</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="row">
                <div class="col-md-2" style="margin-top: 10px; margin-left: 15px;">
                  <select class="form-control form-control-sm" @change="onChange($event)">
                    <option disabled selected>Kullanıcı Seçiniz</option>
                    <option v-for="data in userLog" :key="data.id" :value="data.id">
                          {{ data.username }} 
                    </option>
                  </select>
                </div>
              <div class="card-header card-title" style="margin-left: 65%;">
                Kullanıcı listesi              
              </div>             
              </div>          
              <div class="card-body table-responsive p-0">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th >#</th>
                        <th>Kullanıcı</th>
                        <th>Denediği Şifre </th>
                        <th >Kullanıcı IP</th>
                        <th >Başarısız Giriş Tarihi</th>
                        <th>Son Başarılı Giriş</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in datatable">
                        <td>#</td>
                        <td>
                          {{ item.username }} 
                        </td>
                        <td>{{ item.passwordinserted }}</td>
                        <td>{{ item.ipaddress }}</td>
                        <td>{{ item.flogindate | DateFormat }}</td>
                        <td>{{ item.Lastlogin | DateFormat}}</td>                    
                      </tr>
                      <tr>
                        <td v-if="datatable.length == 0" colspan="6" class="text-center">
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="perPage" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->

   
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      perPage: 10,
      rows: 0,
      userList: [],
      userLog :[],
      overlay: false,
      datatable: [],
      department: {
        name: "",
        description: "",
      },
    };
  },
  methods: {
    pagination(value) {
      var count = (value - 1) * this.perPage;
      this.datatable = this.userList.slice(count, count + this.perPage);
    },
    onChange(event) {           
            this.getDatas(event.target.value);
        },
    getDatas(id) {
      this.overlay = true;
      this.$http.get(`UserLogs/UserLogList/${id}`).then((response) => {
        this.userList = response.data;
        this.datatable = this.userList.slice(0, this.perPage);
        this.rows = this.userList.length;
        this.overlay = false;
      });
    },  
    getuserName()
    {
      this.$http.get(`UserLogs/GetUserLogList/`).then((response) => {
        this.userLog = response.data;  
      });
    }
  },
  filters: {
    DateFormat(value) {
      if (!value) return "İşlem Sırasında";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.getDatas();
    this.getuserName();
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UserLogs/UserLogsList.vue